/**
 * 会员管理模块接口列表
 */

import base from './base'; // 导入接口域名列表
import axios from './axios';
import qs from 'qs';
//获取会员列表
export const getListClient = (params) => {

    return axios.post(`${base.base}/client/get_list_client`,
        qs.stringify(params)
    )
};
//添加会员
export const insertClient = (params) => {
    return axios.post(`${base.base}/client/insert_client`,
        qs.stringify(params)
    )
};
//修改会员
export const updateClient = (params) => {
    return axios.post(`${base.base}/client/update_client`,
        qs.stringify(params)
    )
};
//删除会员
export const deleteClient = (params) => {
    return axios.post(`${base.base}/client/delete_client`,
        qs.stringify(params)
    )
};
export default getListClient;


// WEBPACK FOOTER //
// ./src/api/client.js